const initializedSections = new WeakSet();
const cardsTitlesMedia = window.matchMedia('(min-width: 769px)');

const initCardsSection = (scope = document) => {
  const sections = scope.matches?.('.cards-sec') ? [scope] : scope.querySelectorAll('.cards-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const titles = section.querySelectorAll('.cards-sec__title');

    if (!titles.length || typeof window.lineTitlesFunc !== 'function') {
      return;
    }

    let titlesController = null;

    const syncTitles = () => {
      if (cardsTitlesMedia.matches) {
        if (!titlesController) {
          titlesController = window.lineTitlesFunc(titles);
        }

        return;
      }

      if (titlesController) {
        titlesController.destroy();
        titlesController = null;
      }
    };

    syncTitles();
    cardsTitlesMedia.addEventListener('change', syncTitles);
    initializedSections.add(section);
  });
};

initCardsSection();
window.initCardsSection = initCardsSection;
